module.exports = __webpack_public_path__ + "img/Show you can.808c4777.svg";